import { useQuery } from '@tanstack/react-query';

const S3_FILES_API_URL =
  'https://2in4lfzzgv6kbksjj56yi46bzi0yidto.lambda-url.ap-northeast-2.on.aws/';

const fetchS3Files = async (): Promise<string[]> => {
  const response = await fetch(S3_FILES_API_URL);
  if (!response.ok) {
    throw new Error('S3 파일 목록을 불러오는데 실패했습니다.');
  }
  return response.json();
};

export const useS3Files = () => {
  return useQuery({
    queryKey: ['s3Files'],
    queryFn: fetchS3Files,
  });
};
